import { css } from "@emotion/react";
import Skeleton from "@mui/material/Skeleton";

import { colors } from "@dotnet/telematics-design-system";

import { useMediaQueries } from "shared/hooks/useMediaQueries";

const CompanyFilterLoader = () => {
    const { gray100 } = colors;

    const { toSm } = useMediaQueries();

    return toSm ? (
        <Skeleton
            variant="rectangular"
            width={36}
            height={36}
            css={css({
                background: gray100,
                borderRadius: "6px"
            })}
        />
    ) : (
        <Skeleton
            variant="rectangular"
            width={160}
            height={36}
            css={css({
                background: gray100,
                borderRadius: "6px"
            })}
        />
    );
};

export default CompanyFilterLoader;
